import { computed, MaybeRefOrGetter, ref, toValue } from 'vue'
import { useOCR } from '@/shared/composables/useOCR/useOCR'

interface useOcrSignalsOptions {
  nationalityIso: MaybeRefOrGetter<string>,
  isOcrAvailable: boolean
}

export const useOcrSignals = (options: useOcrSignalsOptions) => {
  const nationalityIsoRef = computed(() => toValue(options.nationalityIso))
  const ocr = useOCR(nationalityIsoRef)

  const isOcrManualMode = ref(false)

  const isFileUploaderShown = computed(
    () => ['in', 'pk'].includes(nationalityIsoRef.value) && options.isOcrAvailable
  )

  const isNotOcrManualMode = computed(
    () => !isOcrManualMode.value && isFileUploaderShown.value
  )

  return {
    ocr,
    isOcrManualMode,
    isFileUploaderShown,
    isNotOcrManualMode,
  }
}

export type OcrSignals = ReturnType<typeof useOcrSignals>
